import Vue from "vue";
import Vuex from "vuex";
import * as user from "./modules/user";
import * as app from "./modules/app";
import * as appDetail from "./modules/appDetail";
import * as project from "./modules/project";
import * as projectDetail from "./modules/projectDetail";
import * as serviceAccounts from "./modules/serviceAccounts";
import * as customers from "./modules/customers";
import * as dialog from "./modules/dialog";
import * as snackbar from "./modules/snackbar";
import * as sideber from "./modules/sidebar";
import * as appconsole from "./modules/appconsole";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        tooltip: null
    },
    actions: {
        RESET_STORE({ commit, dispatch }) {
            commit("RESET_LOGIN_INFO");

            // app
            commit("SET_APPS", []);

            // project
            dispatch("RESET_PROJECTS");

            // appDetail
            commit("RESET_APP_DETAIL");

            // projectDetail
            commit("RESET_DEVELOPER_PROJECT_DETAIL");
            dispatch("RESET_PROJECT_DETAIL");
        },
        async UPDATE_TOOLTIP({ state: { tooltip }, commit }, value = {}) {
            if (!value.id || value.id === tooltip?.id) return;
            if (tooltip) {
                commit("SET_TOOLTIP", null);
                await Vue.nextTick();
            }
            commit("SET_TOOLTIP", value);
        }
    },
    mutations: {
        SET_TOOLTIP(state, tooltip) {
            state.tooltip = tooltip;
        }
    },
    modules: {
        user,
        app,
        appDetail,
        project,
        projectDetail,
        serviceAccounts,
        customers,
        dialog,
        snackbar,
        sideber,
        appconsole
    }
});
